var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog305(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_305"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_305",
    "data-name": 305,
    className: "cls-2",
    d: "M51.78,1.4C35.67,1,28.05,19.11,24.89,32.15,20.6,49.83,21.45,99.24,50.31,98.51c28.59-.73,30.88-53.11,23.1-71.86C71.24,21.42,63.06,1.69,51.78,1.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog305);
export default __webpack_public_path__ + "static/media/dog_305.40383ea2b1838b2b399ef3c5f198c424.svg";
export { ForwardRef as ReactComponent };